module.exports = require("@gauzy/plugin-integration-upwork");